export const actionTypes = {
  REQUEST_START: 'MESSAGES.RELATED_APPEALS.REQUEST_START',
  REQUEST_SUCCESS: 'MESSAGES.RELATED_APPEALS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'MESSAGES.RELATED_APPEALS.REQUEST_FAILURE',
};

export function startRequest(cardId) {
  return {
    type: actionTypes.REQUEST_START,
    payload: cardId,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
